import jwt from 'jsonwebtoken';

const { REACT_APP_JWT_SECRET } = process.env;

const ALGORITHM = "HS256";
const AUDIENCE = "https://geopoly.io";
const ISSUER = "https://geopoly.io";

const signOptions = {
    algorithm: ALGORITHM,
    audience: AUDIENCE,
    issuer: ISSUER,
};

const sign = (payload) => jwt.sign(payload, REACT_APP_JWT_SECRET, signOptions);

const jwtService = {
    sign,
};

export default jwtService;